/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EnrollmentUpdateModel } from '../models';
// @ts-ignore
import type { GetProviderPayerMeta200Response } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PayerAddModel } from '../models';
// @ts-ignore
import type { PayerAdminModel } from '../models';
// @ts-ignore
import type { PayerSearchModel } from '../models';
// @ts-ignore
import type { PayerUpdateModel } from '../models';
// @ts-ignore
import type { ProviderPayerMetaPatchModel } from '../models';
// @ts-ignore
import type { ProviderSearchModel } from '../models';
/**
 * PayersApi - axios parameter creator
 * @export
 */
export const PayersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PayerSearchModel} payerSearchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayers: async (payerSearchModel: PayerSearchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerSearchModel' is not null or undefined
            assertParamExists('getPayers', 'payerSearchModel', payerSearchModel)
            const localVarPath = `/api/v1/payer/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payerSearchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} payerId 
         * @param {ProviderSearchModel} providerSearchModel 
         * @param {boolean} [allProviders] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderPayerMeta: async (payerId: string, providerSearchModel: ProviderSearchModel, allProviders?: boolean, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('getProviderPayerMeta', 'payerId', payerId)
            // verify required parameter 'providerSearchModel' is not null or undefined
            assertParamExists('getProviderPayerMeta', 'providerSearchModel', providerSearchModel)
            const localVarPath = `/api/v1/payer/{payerId}/providers`
                .replace(`{${"payerId"}}`, encodeURIComponent(String(payerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (allProviders !== undefined) {
                localVarQueryParameter['allProviders'] = allProviders;
            }

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerSearchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<PayerUpdateModel>} payerUpdateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPayer: async (payerUpdateModel: Array<PayerUpdateModel>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerUpdateModel' is not null or undefined
            assertParamExists('patchPayer', 'payerUpdateModel', payerUpdateModel)
            const localVarPath = `/api/v1/payer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payerUpdateModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} payerId 
         * @param {Array<ProviderPayerMetaPatchModel>} providerPayerMetaPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProviderPayerMeta: async (payerId: string, providerPayerMetaPatchModel: Array<ProviderPayerMetaPatchModel>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('patchProviderPayerMeta', 'payerId', payerId)
            // verify required parameter 'providerPayerMetaPatchModel' is not null or undefined
            assertParamExists('patchProviderPayerMeta', 'providerPayerMetaPatchModel', providerPayerMetaPatchModel)
            const localVarPath = `/api/v1/payer/{payerId}/providers`
                .replace(`{${"payerId"}}`, encodeURIComponent(String(payerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerPayerMetaPatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PayerAddModel} payerAddModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPayer: async (payerAddModel: PayerAddModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerAddModel' is not null or undefined
            assertParamExists('postPayer', 'payerAddModel', payerAddModel)
            const localVarPath = `/api/v1/payer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payerAddModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} payerId 
         * @param {Array<EnrollmentUpdateModel>} enrollmentUpdateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnrollment: async (payerId: string, enrollmentUpdateModel: Array<EnrollmentUpdateModel>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payerId' is not null or undefined
            assertParamExists('updateEnrollment', 'payerId', payerId)
            // verify required parameter 'enrollmentUpdateModel' is not null or undefined
            assertParamExists('updateEnrollment', 'enrollmentUpdateModel', enrollmentUpdateModel)
            const localVarPath = `/api/v1/payer/{payerId}/providers/enrollment`
                .replace(`{${"payerId"}}`, encodeURIComponent(String(payerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enrollmentUpdateModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PayersApi - functional programming interface
 * @export
 */
export const PayersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PayersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PayerSearchModel} payerSearchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayers(payerSearchModel: PayerSearchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayerAdminModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayers(payerSearchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayersApi.getPayers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} payerId 
         * @param {ProviderSearchModel} providerSearchModel 
         * @param {boolean} [allProviders] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviderPayerMeta(payerId: string, providerSearchModel: ProviderSearchModel, allProviders?: boolean, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProviderPayerMeta200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviderPayerMeta(payerId, providerSearchModel, allProviders, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayersApi.getProviderPayerMeta']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<PayerUpdateModel>} payerUpdateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPayer(payerUpdateModel: Array<PayerUpdateModel>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPayer(payerUpdateModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayersApi.patchPayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} payerId 
         * @param {Array<ProviderPayerMetaPatchModel>} providerPayerMetaPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchProviderPayerMeta(payerId: string, providerPayerMetaPatchModel: Array<ProviderPayerMetaPatchModel>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchProviderPayerMeta(payerId, providerPayerMetaPatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayersApi.patchProviderPayerMeta']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PayerAddModel} payerAddModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPayer(payerAddModel: PayerAddModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayerAdminModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPayer(payerAddModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayersApi.postPayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} payerId 
         * @param {Array<EnrollmentUpdateModel>} enrollmentUpdateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEnrollment(payerId: string, enrollmentUpdateModel: Array<EnrollmentUpdateModel>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEnrollment(payerId, enrollmentUpdateModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayersApi.updateEnrollment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PayersApi - factory interface
 * @export
 */
export const PayersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PayersApiFp(configuration)
    return {
        /**
         * 
         * @param {PayersApiGetPayersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayers(requestParameters: PayersApiGetPayersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PayerAdminModel>> {
            return localVarFp.getPayers(requestParameters.payerSearchModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PayersApiGetProviderPayerMetaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviderPayerMeta(requestParameters: PayersApiGetProviderPayerMetaRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetProviderPayerMeta200Response> {
            return localVarFp.getProviderPayerMeta(requestParameters.payerId, requestParameters.providerSearchModel, requestParameters.allProviders, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PayersApiPatchPayerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPayer(requestParameters: PayersApiPatchPayerRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchPayer(requestParameters.payerUpdateModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PayersApiPatchProviderPayerMetaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProviderPayerMeta(requestParameters: PayersApiPatchProviderPayerMetaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchProviderPayerMeta(requestParameters.payerId, requestParameters.providerPayerMetaPatchModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PayersApiPostPayerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPayer(requestParameters: PayersApiPostPayerRequest, options?: RawAxiosRequestConfig): AxiosPromise<PayerAdminModel> {
            return localVarFp.postPayer(requestParameters.payerAddModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PayersApiUpdateEnrollmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnrollment(requestParameters: PayersApiUpdateEnrollmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateEnrollment(requestParameters.payerId, requestParameters.enrollmentUpdateModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PayersApi - interface
 * @export
 * @interface PayersApi
 */
export interface PayersApiInterface {
    /**
     * 
     * @param {PayersApiGetPayersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApiInterface
     */
    getPayers(requestParameters: PayersApiGetPayersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PayerAdminModel>>;

    /**
     * 
     * @param {PayersApiGetProviderPayerMetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApiInterface
     */
    getProviderPayerMeta(requestParameters: PayersApiGetProviderPayerMetaRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetProviderPayerMeta200Response>;

    /**
     * 
     * @param {PayersApiPatchPayerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApiInterface
     */
    patchPayer(requestParameters: PayersApiPatchPayerRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {PayersApiPatchProviderPayerMetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApiInterface
     */
    patchProviderPayerMeta(requestParameters: PayersApiPatchProviderPayerMetaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {PayersApiPostPayerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApiInterface
     */
    postPayer(requestParameters: PayersApiPostPayerRequest, options?: RawAxiosRequestConfig): AxiosPromise<PayerAdminModel>;

    /**
     * 
     * @param {PayersApiUpdateEnrollmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApiInterface
     */
    updateEnrollment(requestParameters: PayersApiUpdateEnrollmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for getPayers operation in PayersApi.
 * @export
 * @interface PayersApiGetPayersRequest
 */
export interface PayersApiGetPayersRequest {
    /**
     * 
     * @type {PayerSearchModel}
     * @memberof PayersApiGetPayers
     */
    readonly payerSearchModel: PayerSearchModel
}

/**
 * Request parameters for getProviderPayerMeta operation in PayersApi.
 * @export
 * @interface PayersApiGetProviderPayerMetaRequest
 */
export interface PayersApiGetProviderPayerMetaRequest {
    /**
     * 
     * @type {string}
     * @memberof PayersApiGetProviderPayerMeta
     */
    readonly payerId: string

    /**
     * 
     * @type {ProviderSearchModel}
     * @memberof PayersApiGetProviderPayerMeta
     */
    readonly providerSearchModel: ProviderSearchModel

    /**
     * 
     * @type {boolean}
     * @memberof PayersApiGetProviderPayerMeta
     */
    readonly allProviders?: boolean

    /**
     * 
     * @type {number}
     * @memberof PayersApiGetProviderPayerMeta
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof PayersApiGetProviderPayerMeta
     */
    readonly pgSize?: number
}

/**
 * Request parameters for patchPayer operation in PayersApi.
 * @export
 * @interface PayersApiPatchPayerRequest
 */
export interface PayersApiPatchPayerRequest {
    /**
     * 
     * @type {Array<PayerUpdateModel>}
     * @memberof PayersApiPatchPayer
     */
    readonly payerUpdateModel: Array<PayerUpdateModel>
}

/**
 * Request parameters for patchProviderPayerMeta operation in PayersApi.
 * @export
 * @interface PayersApiPatchProviderPayerMetaRequest
 */
export interface PayersApiPatchProviderPayerMetaRequest {
    /**
     * 
     * @type {string}
     * @memberof PayersApiPatchProviderPayerMeta
     */
    readonly payerId: string

    /**
     * 
     * @type {Array<ProviderPayerMetaPatchModel>}
     * @memberof PayersApiPatchProviderPayerMeta
     */
    readonly providerPayerMetaPatchModel: Array<ProviderPayerMetaPatchModel>
}

/**
 * Request parameters for postPayer operation in PayersApi.
 * @export
 * @interface PayersApiPostPayerRequest
 */
export interface PayersApiPostPayerRequest {
    /**
     * 
     * @type {PayerAddModel}
     * @memberof PayersApiPostPayer
     */
    readonly payerAddModel: PayerAddModel
}

/**
 * Request parameters for updateEnrollment operation in PayersApi.
 * @export
 * @interface PayersApiUpdateEnrollmentRequest
 */
export interface PayersApiUpdateEnrollmentRequest {
    /**
     * 
     * @type {string}
     * @memberof PayersApiUpdateEnrollment
     */
    readonly payerId: string

    /**
     * 
     * @type {Array<EnrollmentUpdateModel>}
     * @memberof PayersApiUpdateEnrollment
     */
    readonly enrollmentUpdateModel: Array<EnrollmentUpdateModel>
}

/**
 * PayersApi - object-oriented interface
 * @export
 * @class PayersApi
 * @extends {BaseAPI}
 */
export class PayersApi extends BaseAPI implements PayersApiInterface {
    /**
     * 
     * @param {PayersApiGetPayersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApi
     */
    public getPayers(requestParameters: PayersApiGetPayersRequest, options?: RawAxiosRequestConfig) {
        return PayersApiFp(this.configuration).getPayers(requestParameters.payerSearchModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PayersApiGetProviderPayerMetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApi
     */
    public getProviderPayerMeta(requestParameters: PayersApiGetProviderPayerMetaRequest, options?: RawAxiosRequestConfig) {
        return PayersApiFp(this.configuration).getProviderPayerMeta(requestParameters.payerId, requestParameters.providerSearchModel, requestParameters.allProviders, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PayersApiPatchPayerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApi
     */
    public patchPayer(requestParameters: PayersApiPatchPayerRequest, options?: RawAxiosRequestConfig) {
        return PayersApiFp(this.configuration).patchPayer(requestParameters.payerUpdateModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PayersApiPatchProviderPayerMetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApi
     */
    public patchProviderPayerMeta(requestParameters: PayersApiPatchProviderPayerMetaRequest, options?: RawAxiosRequestConfig) {
        return PayersApiFp(this.configuration).patchProviderPayerMeta(requestParameters.payerId, requestParameters.providerPayerMetaPatchModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PayersApiPostPayerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApi
     */
    public postPayer(requestParameters: PayersApiPostPayerRequest, options?: RawAxiosRequestConfig) {
        return PayersApiFp(this.configuration).postPayer(requestParameters.payerAddModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PayersApiUpdateEnrollmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayersApi
     */
    public updateEnrollment(requestParameters: PayersApiUpdateEnrollmentRequest, options?: RawAxiosRequestConfig) {
        return PayersApiFp(this.configuration).updateEnrollment(requestParameters.payerId, requestParameters.enrollmentUpdateModel, options).then((request) => request(this.axios, this.basePath));
    }
}

